import { FormSpy, useFormApi } from '@data-driven-forms/react-form-renderer';
import { UnnamedWidget } from 'lib-node-amb-renderer';
import { useEffect, useState } from 'react';

import ChakraText from '~/common/componentMapper/Text';

const formatWithDecimals = new Intl.NumberFormat(undefined, {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});
const currencyFormat = (strNum: string | number) => {
  const n = Number(strNum);
  return formatWithDecimals.format(n);
};

function overrideAmountExists(override: string, overrideAmount: any): boolean {
  return (
    override === 'true' &&
    overrideAmount !== null &&
    overrideAmount !== undefined &&
    overrideAmount !== ''
  );
}

function accumulateMonthlyIncome(
  accum: number,
  calculationResultAmount: any,
  override: string,
  overrideAmount: any,
): number {
  let n = Number(calculationResultAmount);

  if (overrideAmountExists(override, overrideAmount)) {
    n = Number(overrideAmount);
  }

  if (Number.isNaN(n)) {
    n = 0;
  }

  accum += n;

  return accum;
}

export class MonthlyCalculator extends UnnamedWidget {
  prefix;
  constructor(props) {
    super(props);
    this.prefix = props.prefix;
  }
}
export default function ReviewBreakdownDetails(
  props: Readonly<React.ComponentProps<typeof InnerComponent>>,
) {
  return (
    // @ts-expect-error The spelling on this prop is wrong, but need to test to make sure it works
    <FormSpy subcription={{ values: true }}>
      {() => <InnerComponent {...props} />}
    </FormSpy>
  );
}
type InnerComponentProps = {
  name?: string;
  prefix?: string;
};
function InnerComponent({
  name,
  prefix,
  ...rest
}: Readonly<InnerComponentProps>) {
  const { getState } = useFormApi();
  const { values } = getState();
  const [calculated, setCalculated] = useState<string | number>('');
  const calculationId = `${prefix}${values.calculationId}`;
  const outcomeDetails =
    values.calculationDetails[calculationId].outcomeDetails;

  useEffect(() => {
    const values = Object.values(outcomeDetails) as any;
    const total = values.reduce(
      (
        accum: number,
        { calculationResultAmount, override, overrideAmount },
      ) => {
        return accumulateMonthlyIncome(
          accum,
          calculationResultAmount,
          override,
          overrideAmount,
        );
      },
      0,
    );
    setCalculated(total);
    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, [values]);

  return (
    <ChakraText
      bgColor="bgGray.100"
      p="24px"
      id={name}
      fontSize="lg"
      word-spacing={4}
      marginBottom={1}
      width="100%"
      {...rest}
    >
      <strong style={{ marginRight: '1rem' }}>Monthly Income</strong>
      {currencyFormat(calculated)}
    </ChakraText>
  );
}
